export default "__VITE_ASSET__DUT5UB1o__"